<template>
  <div :class="`hm-alert-info ${status}`">
    <div class="mr-2" v-if="showIcon">
      <slot name="icon">
        <i class="far fa-info-circle"></i>
      </slot>
    </div>
    <div class="banner-content">
      <slot>
        <span v-html="sanitize(text)"></span>
      </slot>
    </div>
    <div class="ml-2" v-if="$slots.options">
      <slot name="options"></slot>
    </div>
  </div>
</template>

<script>
import { sanitize } from '@/core/utils/utils';

export default {
  name: 'HMAlertInfo',
  props: {
    text: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: 'danger',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    sanitize,
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-alert-info {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border-radius: $border-radius;
  &.success {
    background-color: $light-green;
    color: $forest;
  }
  &.danger {
    background-color: $light-bubblegum;
    color: $dark-red;
  }
  &.outline {
    color: $dark-gray;
    border: 1px solid $light-gray;
  }
}

.banner-content {
  flex: 1;
}
</style>
